import { getLabelMessage } from '@gef-ui/localization/messages';
import ChevronDown from '@gef-ui/material-icons/ChevronDown';
import ChevronUp from '@gef-ui/material-icons/ChevronUp';
import { sxPropType } from '@gef-ui/material/components/utils';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useDefaultComponentValue } from '../../utils';
const getChevronStyles = (theme)=>{
    return {
        width: 10,
        height: 10,
        marginLeft: theme.spacing(0.5),
        fill: theme.palette.primary.main
    };
};
const StyledChevronDown = styled(ChevronDown)(({ theme })=>getChevronStyles(theme));
const StyledChevronUp = styled(ChevronUp)(({ theme })=>getChevronStyles(theme));
const CollapseButton = styled(Button)(({ theme })=>({
        color: theme.palette.primary.main,
        margin: theme.spacing(0, 0, 1, 3),
        [theme.breakpoints.down('md')]: {
            margin: theme.spacing(0.5, 0, 1)
        }
    }));
CollapseButton.defaultProps = {
    variant: 'body2'
};
const COMPONENT_NAME = 'MuiErrorInfo';
const ErrorInfo = (inProps)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { shortDescription, longDescription, collapsible = false, infoSx } = props;
    const [isCollapsed, setIsCollapsed] = useState(collapsible);
    const toggleCollapse = ()=>setIsCollapsed(!isCollapsed);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, collapsible && /*#__PURE__*/ React.createElement(CollapseButton, {
        onClick: toggleCollapse,
        endIcon: isCollapsed ? /*#__PURE__*/ React.createElement(StyledChevronDown, null) : /*#__PURE__*/ React.createElement(StyledChevronUp, null)
    }, getLabelMessage(`errors:${isCollapsed ? 'show' : 'hide'}FullError`)), !isCollapsed && /*#__PURE__*/ React.createElement(Box, {
        sx: infoSx
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: longDescription ? undefined : {
            mb: 3
        },
        variant: "body2"
    }, shortDescription), longDescription && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            fontWeight: 'bold',
            marginTop: 3
        }
    }, getLabelMessage('errors:fullErrorMessage')), /*#__PURE__*/ React.createElement(Alert, {
        severity: "error",
        sx: (theme)=>({
                margin: theme.spacing(1, 0, 3, 0),
                wordBreak: 'break-word'
            })
    }, longDescription))));
};
ErrorInfo.propTypes = {
    collapsible: PropTypes.bool,
    infoSx: sxPropType,
    longDescription: PropTypes.string,
    shortDescription: PropTypes.string
};
export default ErrorInfo;
